import { forceCast } from '@betgames/bg-tools';
import { t } from '@bg-shared/business/Translate';

export const parseErrorText = (error: Error | { message: string }): string => {
    const messageParts = error.message?.split('|');

    return messageParts?.length > 1
        ? t.error(messageParts[0]).replace('%1', messageParts[1])
        : (error.message && t.error(error.message)) ||
              t.error(forceCast<{ error: string }>(error).error);
};
